import type { Module } from "vuex";
import type { State } from "@/store/state";
import type { AdminState } from "./state";
import { mutations } from "./mutations";
import { getters } from "./getters";
import { actions } from "./actions";

const defaultState: AdminState = {
  users: [],
};

export const adminModule: Module<AdminState, State> = {
  namespaced: true,
  state: defaultState,
  mutations,
  actions,
  getters,
};
